import React from 'react';
import CloseDraftConfirmationModal from 'views/dossiers/components/CloseDraftConfirmationModal';

export interface CloseConfirmationModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function CloseConfirmationModal({
  open,
  onCancel,
  onConfirm,
}: CloseConfirmationModalProps) {
  return (
    <CloseDraftConfirmationModal
      open={open}
      onCancel={onCancel}
      onConfirm={onConfirm}
      translationPrefix="ajout_dossier:close_confirm"
    />
  );
}
